import {FC, PropsWithChildren} from 'react';

import Spinner from './spinner';

const InflowSpinner: FC<PropsWithChildren> = ({children}) => (
  <div className="flex h-full flex-col items-center justify-center">
    <Spinner />
    {children}
  </div>
);

export default InflowSpinner;
